// extracted by mini-css-extract-plugin
export default {"container":"readonly-image_container__aRXso","container__image":"readonly-image_container__image__-CUsL"};